import { fetchData } from '@umu/umu-fetch';
import API from '../../path';
import type { IGestureInfo } from '@umu/umu-types';
export type { IGestureInfo } from '@umu/umu-types';

/**
 * 获取作业动作列表
 * @param {string} params elementId
 * @returns {Promise<IResponse<IGestureInfo[]>>}
 * @date 2022-04-26
 */
export const getHomeworkGestures = (elementId: string | number): Promise<IResponse<IGestureInfo[]>> => {
    return fetchData(API.GET_GESTURE_LIST, {element_id: elementId});
};
